import { InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | undefined;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-content-secondary mb-1">{label}</label>
        )}
        <div className="relative">
          <input
            ref={ref}
            className={`
              block w-full px-3 py-2 border rounded-md shadow-sm placeholder-content-muted
              focus:outline-none focus:ring-1 sm:text-sm transition-colors duration-200
              ${
                error
                  ? 'border-danger text-danger placeholder-danger focus:ring-danger focus:border-danger'
                  : 'border-line-strong focus:ring-brand focus:border-brand'
              }
              ${className}
            `}
            {...props}
          />
        </div>
        {error && <p className="mt-1 text-sm text-danger">{error}</p>}
        {!error && helperText && <p className="mt-1 text-sm text-content-muted">{helperText}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
